import { Component, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { ApsServiceService } from "../aps-service.service";

@Component({
  selector: "app-links",
  templateUrl: "./links.component.html",
  styleUrls: ["./links.component.css"],
})
export class LinksComponent implements OnInit {
  loaderdata:any;
  data:any;
  constructor(private routepage:Router,private route: ActivatedRoute,private searchitem: ApsServiceService,private sanitizer:DomSanitizer) {}
  

  ngOnInit(): void {
    this.getlists();
  }
  getlists = () => {
    this.loaderdata=true;
    this.searchitem.linkItemsdatas().subscribe((responce) => {
      if(responce.status){
      //console.log(responce)
    //  this.data = this.sanitizer.bypassSecurityTrustHtml(responce.data[0].event_details);  
    this.data=responce.datas
    this.loaderdata=false;
  }else{
    this.loaderdata=false;

  }
  
    })
  }


}
